function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

import _ from 'underscore';
import PaginatedCollection from './paginated_collection';
import Backbone from '@polleverywhere/backbone';
import Group from './group';
/*
 * This is a collection of shared groups. It uses JsonAPI
 *   to allow sorting, searching, and pagination.
 *
 * @namespace Model
 *
 */

var SharedGroups = /*#__PURE__*/function (_PaginatedCollection) {
  _inheritsLoose(SharedGroups, _PaginatedCollection);

  function SharedGroups() {
    return _PaginatedCollection.apply(this, arguments) || this;
  }

  var _proto = SharedGroups.prototype;

  _proto.initialize = function initialize(options) {
    if (options === void 0) {
      options = {};
    }

    _PaginatedCollection.prototype.initialize.call(this, options);

    this.model = Group;
    this.url = '/api/groups/shared'; // Handle URL params

    this.params = new Backbone.Model({});
  }
  /*
   * Fetch shared groups using params set on JsonAPI
   *   and options / params passed in
   *
   * @param {options} options Options for fetching
   * @param {data} options.data Parameters for fetching
   */
  ;

  _proto.fetch = function fetch(options) {
    // Default sorting
    if (options == null) {
      options = {};
    }

    if (!options.data) {
      options.data = {};
    }

    _.defaults(options.data, {
      search: this.params.get('search'),
      sort: this.params.get('sort')
    });

    return _PaginatedCollection.prototype.fetch.call(this, options);
  };

  return SharedGroups;
}(PaginatedCollection);

export { SharedGroups as default };